import Request, { requestCsv } from "utils/requests/api";
import initializeConfig from "utils/requests/api.config";

export const BASE_URL_MANAGEMENT = async () => {
  const { management } = await initializeConfig();
  return `${management}`;
};

export interface IRequestTags {
  _size: number;
  _page: number;
  filter: string;
}

export const getTagsRegister = async ({ _size, _page, filter }: IRequestTags) => {
  const baseUrlManagement = await BASE_URL_MANAGEMENT();

  return (await Request).get(`${baseUrlManagement}tags:paginated`, {
    _size,
    _page,
    filter,
  });
};

export const saveImportCsv = async (formData) => {
  const baseUrlManagement = await BASE_URL_MANAGEMENT();
  return (await requestCsv()).post(`${baseUrlManagement}imports/tags`, formData);
};

export const editTags = async (formData) => {
  const baseUrlManagement = await BASE_URL_MANAGEMENT();
  return (await Request).put(`${baseUrlManagement}tags`, formData);
};

export const getTagById = async ({ id }) => {
  const baseUrlManagement = await BASE_URL_MANAGEMENT();
  return (await Request).get(`${baseUrlManagement}tags/${id}`);
};
